"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _types = require("./types");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.UrlTracking = exports.UrlQuery = exports.UrlParameter = exports.UrlFirstParameter = exports.UrlEventType = exports.NUMBER_OF_RETRIES = exports.Header = exports.DEFAULT_DOMAINS = void 0;
var NUMBER_OF_RETRIES = exports.NUMBER_OF_RETRIES = 2;
var Header = exports.Header = function (a) {
  return a.UserAgent = "User-Agent", a.ContentType = "Content-Type", a.SdkVersion = "X-Kameleoon-SDK-Version", a.SdkType = "X-Kameleoon-SDK-Type", a.Authorization = "Authorization", a.AcceptEncoding = "Accept-Encoding", a;
}({});
var UrlEventType = exports.UrlEventType = {
    CustomData: "eventType=customData",
    StaticData: "eventType=staticData",
    Page: "eventType=page",
    Conversion: "eventType=conversion",
    Activity: "eventType=activity",
    Experiment: "eventType=experiment",
    Geolocation: "eventType=geolocation"
  },
  UrlParameter = exports.UrlParameter = {
    Title: "&title=",
    ReferrersIndices: "&referrersIndices=",
    Negative: "&negative=",
    Revenue: "&revenue=",
    Overwrite: "&overwrite=",
    Index: "&index=",
    BrowserIndex: "&browserIndex=",
    BrowserVersion: "&browserVersion=",
    Href: "&href=",
    DeviceType: "&deviceType=",
    SiteCode: "&siteCode=",
    GoalId: "&goalId=",
    VisitorCode: "&visitorCode=",
    VariationId: "&variationId=",
    Ts: "&ts=",
    Key: "&key=",
    SdkName: "&sdkName=",
    SdkVersion: "&sdkVersion=",
    ValuesCountMap: "&valuesCountMap=",
    Nonce: "&nonce=",
    Id: "&id=",
    CustomData: "&customData=",
    CurrentVisit: "&currentVisit=",
    MaxNumberPreviousVisits: "&maxNumberPreviousVisits=",
    Os: "&os=",
    OsIndex: "&osIndex=",
    Country: "&country=",
    City: "&city=",
    Region: "&region=",
    Latitude: "&latitude=",
    Longitude: "&longitude=",
    PostalCode: "&postalCode=",
    Conversion: "&conversion=",
    StaticData: "&staticData=",
    Geolocation: "&geolocation=",
    Page: "&page=",
    Experiment: "&experiment=",
    Browser: "&browser=",
    Environment: "&environment=",
    MappingIdentifier: "&mappingIdentifier=",
    MappingValue: "&mappingValue=",
    Kcs: "&kcs=",
    UserAgent: "&userAgent=",
    BodyUa: "&bodyUa="
  },
  UrlFirstParameter = exports.UrlFirstParameter = {
    CustomData: "?customData=",
    StaticData: "?staticData=",
    Page: "?page=",
    Conversion: "?conversion=",
    Geolocation: "?geolocation=",
    Experiment: "?experiment=",
    ValuesCountMap: "?valuesCountMap=",
    Id: "?id=",
    Nonce: "?nonce=",
    Country: "?country=",
    Environment: "?environment=",
    City: "?city=",
    Region: "?region=",
    Latitude: "?latitude=",
    Longitude: "?longitude=",
    PostalCode: "?postalCode=",
    SdkName: "?sdkName=",
    SdkVersion: "?sdkVersion=",
    BrowserIndex: "?browserIndex=",
    BrowserVersion: "?browserVersion=",
    SiteCode: "?siteCode=",
    VisitorCode: "?visitorCode=",
    CurrentVisit: "?currentVisit=",
    MaxNumberPreviousVisits: "?maxNumberPreviousVisits=",
    Negative: "?negative=",
    Revenue: "?revenue=",
    Title: "?title=",
    Os: "?os=",
    OsIndex: "?osIndex=",
    Browser: "?browser=",
    ReferrersIndices: "?referrersIndices=",
    Overwrite: "?overwrite=",
    Index: "?index=",
    Href: "?href=",
    VariationId: "?variationId=",
    DeviceType: "?deviceType=",
    GoalId: "?goalId=",
    Ts: "?ts=",
    Key: "?key=",
    MappingIdentifier: "?mappingIdentifier=",
    MappingValue: "?mappingValue=",
    Kcs: "?kcs=",
    UserAgent: "?userAgent=",
    BodyUa: "?bodyUa="
  },
  UrlQuery = exports.UrlQuery = {
    Sse: "sse?siteCode=",
    Map: "map?siteCode=",
    Events: "events?siteCode=",
    Visitor: "visitor?siteCode="
  },
  UrlTracking = exports.UrlTracking = {
    Visit: "visit/",
    Map: "map/"
  },
  DEFAULT_DOMAINS = exports.DEFAULT_DOMAINS = _defineProperty(_defineProperty(_defineProperty({}, _types.UrlType.DataApi, "data.kameleoon.io"), _types.UrlType.Events, "events.kameleoon.eu"), _types.UrlType.ClientConfiguration, "sdk-config.kameleoon.eu");